import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./responsive.css";

// Components
import PageTransitionManager from "./PageTransitionManager";
import NavigationBar from "./components/NavigationBar";

function App() {
  return (
    <Router>
      <div className="App" style={{ minHeight: "100vh", position: "relative" }}>
        <NavigationBar />

        <div>
          <PageTransitionManager />
        </div>
      </div>
    </Router>
  );
}

export default App;
